import { render } from "./Entertainment.vue?vue&type=template&id=1afcdb9c&scoped=true"
import script from "./Entertainment.vue?vue&type=script&lang=js"
export * from "./Entertainment.vue?vue&type=script&lang=js"

import "./Entertainment.vue?vue&type=style&index=0&id=1afcdb9c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1afcdb9c"

export default script